import { Flex, Text } from '@chakra-ui/react'
import { useExperienceManager } from '@hooks'
import InfoIcon from '@material-ui/icons/Info'
import moment from 'moment'
import React from 'react'

export const PlusFreeTrialStatus = () => {
  const { daysRemainingInPlusPlanFreeTrial, plusPlanFreeTrialEndDate } =
    useExperienceManager()
  const isFreeTrialExpired = moment(plusPlanFreeTrialEndDate).isBefore(moment())

  return (
    <Flex
      bg={isFreeTrialExpired ? '#FFF2F2' : '#E5FAEE'}
      p="12px"
      borderRadius="4px"
      justifyContent="space-between"
      flexDirection="column"
    >
      <Flex alignItems="center">
        <InfoIcon style={{ fill: '#2D54E8' }} />
        <Flex flexDirection={'column'} ml={'8px'}>
          {isFreeTrialExpired ? (
            <Text>Free trial ended</Text>
          ) : (
            <Text>
              {daysRemainingInPlusPlanFreeTrial} days left of free trial
            </Text>
          )}
        </Flex>
      </Flex>
    </Flex>
  )
}
